import { configureCloudProviderApiBaseUrls } from '../utils/configure-cloud-provider-api-base-urls';
import { makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environmentProvider } from '@shared/environment-provider';
import {
  authenticationEnvironment,
  authwsEnvironment,
  ciphMessageExporterEnvironment,
  dataAccessEnvironment,
  trimbleIdentityEnvironment,
  tripManagementSettingsEnvironment,
  partnerBundleEnvironment,
} from '@tmx/data-access';
import { EMPTY } from 'rxjs';

let configured = false;

export const configureDataAccessEnvironment = (config?: {
  errorHandler?: () => void;
}) =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = (() => {
        if (!configured) {
          try {
            const urls = environmentProvider.getServiceApiBaseUrls();

            authwsEnvironment.baseUrl = urls.authWsApiBaseUrl;
            authenticationEnvironment.baseUrl = urls.authenticationApiBaseUrl;
            trimbleIdentityEnvironment.baseUrl = urls.trimbleIdentityApiBaseUrl;
            tripManagementSettingsEnvironment.baseUrl =
              urls.tripManagementSettingsApiBaseUrl;
            ciphMessageExporterEnvironment.baseUrl =
              urls.cpihMessageExporterApiBaseUrl;
            partnerBundleEnvironment.baseUrl = urls.partnerBundleApiBaseUrl;

            configureCloudProviderApiBaseUrls('AWS');

            dataAccessEnvironment.pcmWsApiKey =
              environmentProvider.getEnvironment().pcMilerWebServicesApiKey;
            dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi =
              true;

            configured = true;
          } catch (error) {
            if (config?.errorHandler) {
              config.errorHandler();
            }
          }
        }

        return () => EMPTY;
      })();
      return initializerFn();
    }),
  ]);
